import React from 'react';
import PropTypes from 'prop-types';

import Modal from 'components/Modal';

const DemoModal = ({
  show,
  closeDemoModal,
  videoSrc = 'https://www.youtube.com/embed/vkx366sknD4',
}) => (
  <Modal
    show={show}
    toggleModal={closeDemoModal}
    contentProps={{
      style: {
        maxWidth: '90vw',
        width: '100%',
        maxHeight: '90vh',
        height: '100%',
        padding: '60px 30px 30px',
      },
    }}>
    {show && (
      <iframe
        width="100%"
        height="100%"
        src={videoSrc}
        frameBorder="0"
        title="ruttl demo"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    )}
  </Modal>
);

DemoModal.propTypes = {
  show: PropTypes.bool.isRequired,
  closeDemoModal: PropTypes.func.isRequired,
  videoSrc: PropTypes.string,
};

export default DemoModal;
